import Head from "next/head";
import React, { useLayoutEffect } from "react";
import { ExtendedNextPage } from "types/pages";

import axios from "axios";
import useAsyncState from "hooks/use-async-state";
import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import Contact from "components/Contact";
import Benefits from "./components/Benefits";
import Heading from "./components/Heading";
import JoinUs from "./components/JoinUs";
import OurInvestors from "./components/OurInvestors";
import OurMission from "./components/OurMisson";

import styles from "./styles.module.scss";
import { formatJobData } from "./components/JoinUs/utils";
import { Opening } from "./components/JoinUs/types";

type Props = {
  openings: Opening[];
};

const About: ExtendedNextPage<Props> = () => {
  const {
    data: openings,
    refresh,
    inProgress
  } = useAsyncState([], async () => {
    const { data: greenhouseData } = await axios.get(
      "https://boards-api.greenhouse.io/v1/boards/humminghomes/jobs?content=true"
    );

    return formatJobData(greenhouseData);
  });

  useLayoutEffect(() => {
    refresh();
  }, []);

  return (
    <div className={styles.container}>
      <Head>
        <title>About Us | Meet Our Co-founders | Humming Homes</title>
        <meta
          name="description"
          content="Meet our co-founders and learn a little bit more about how our mission. "
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/about" />
      </Head>
      <Heading />
      <OurInvestors />
      <OurMission />
      <Benefits />
      <JoinUs loading={inProgress} openings={openings} />
      <Contact />
    </div>
  );
};

About.getLayout = (page) => {
  return (
    <div>
      <HummingNav />
      {page}
      <HummingFooter />
    </div>
  );
};

export default About;
